export default __webpack_public_path__ + "static/media/logo3.4dff0382.png";